// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-comments-post .v-textarea textarea{margin-top:6px;max-height:80px!important}", ""]);
// Exports
module.exports = exports;
